import Numeral from 'numeral';
import d3 from 'd3';
import nv from 'nvd3';
import moment from 'moment-timezone';
import 'linkifyjs/dist/linkify.js';
import 'linkifyjs/dist/linkify-jquery.js';
import { getUser } from '~/services/user/info';


window.moment = moment;
window.numeral = Numeral;
window.nv = nv;
window.user = getUser();

import { LoginSpoof } from './authentication/login_spoof';
import './authentication/login_spoof';
import './tcpa-disclaimer';
import './lead-actions';
import './marketing-overview/marketing-overview-table';
import './marketing-overview/marketing-overview';
import './data-table/data-table-ajax';
import './data-table/jquery.dtwrap';
import './data-table/jquery.slidepanel';
import './users/user-table';
import './connection-graph';
import './site-pages/page-form';
import './activity-stream/activity-form';
import './users/follow-up-report/user-report';
import './loan-report-graphs';
import './email-preview';
import '../assets/js/apps';
import './confirm-modal';
import { hasAccess } from '~/services/permissions/permissions';
import './media-creator/jquery.textfill.js';
import Xss from 'xss';
import { objectToFormData } from '~/utils/utils';
import '~/services/sidebar_controls';
import pendo from '~/services/pendo_service';
import googleTagManager from '~/services/google_tag_manager_service';

window.LoginSpoof = LoginSpoof;
window.xss = Xss;
window.objectToFormData = objectToFormData;
window.hasAccess = hasAccess;

$(() => {


    App.init();

    // unbind specific event in case main page has added it's own on-click event(s).
    $('body').unbind('click.FooterDeleteBtn').on('click.FooterDeleteBtn', 'a.delete-btn', function(e) {
        var btn = $(this);
        e.preventDefault();
        e.stopPropagation();
        confirmModal('Are you absolutely sure you want to delete this permanently?').then(function() {
            if(btn.hasClass('ajax-delete')){
                $.ajax({
                    url: btn.attr("href"),
                    type: 'GET',
                    success: function(data){
                        if(data.status == 1){
                            buildFlashMessage((undefined === data.msg || null === data.msg ? 'Successfully Removed' : data.msg), 'success');
                            $('.item-row[data-row-id="'+data.id+'"]').remove();
                        }
                        else {
                          buildFlashMessage((undefined === data.msg || null === data.msg ? "Operation Failed" : data.msg), 'danger');
                        }
                    },
                    error: function(data) {
                        buildFlashMessage((undefined === data.msg || null === data.msg ? "Operation Failed" : data.msg), 'danger');
                    }
                });
            } else if(btn.hasClass('post-delete')){
                $.ajax({
                    url: btn.attr("href"),
                    data: btn.data('data'),
                    type: 'POST',
                    success: function(data){
                        buildFlashMessage('Successfully Deleted', 'success');
                        $('.item-row[data-row-id="'+data.id+'"]').remove();
                    },
                    error: function(data) {
                        buildFlashMessage('Delete Failed', 'danger');
                    }
                });
            } else {
                window.location.href = btn.attr("href");
            }

        });
    });

    LoginSpoof.initBackToAccount();
    LoginSpoof.initLogout();

    $('.date-picker').datepicker({
        autoclose: true,
        todayHighlight: true
    }).on('show', function() {
        if ($(this).attr('data-date-max-view-mode') == '1') {
            var titleSection = $('.datepicker th.datepicker-switch').eq(0);
            titleSection.text(titleSection.text().replace(/\s+\d+$/, ''));
        }
    });

    $('.time-picker').timepicker();

    $(document).ajaxStart(function () {
        $('body').css('cursor', 'wait');
    }).ajaxStop(function () {
        $('body').css('cursor', 'auto');
    });

    // checks if the sidebar was open or closed on the last page
    if(typeof(Storage) !== "undefined") {
        if(localStorage.getItem("sidebar") == "closed"){
            $("[data-click=sidebar-minify]").trigger( "click" );
        }
    }

    $('.js-expand-nav-search-trigger').on('click', function() {
        var $el = $('.expand-nav-search');
        $el.toggleClass('open');
        if ($el.hasClass('open')) {
            $('.expand-nav-search .form-control').focus();
        }
    });

    // initiate bootstrap select
    $('.selectpicker').selectpicker('render');

    // Turns text into links
    $('.linkify').linkify({
        target: "_blank"
    });

    // Start DataTables
    TableManager.init('.data-table');

    // Handle datatable dropdowns from getting cut off
    dataTableDropdown.init('.data-table, .detach-dropdown');

    $('body').unbind('click.FooterInfoPanelLink').on('click.FooterInfoPanelLink', '.js-info-panel-link', function(e){
        var $btn = $(this);
        e.preventDefault();
        $('.js-info-panel').slidePanel({
            loading_icon_selector: '.dataTables_processing',
            content_url: $(this).attr('href'),
            content_container: $(this).attr('data-content-container'),
            onLoad: function(plugin) {
                if(hasAccess('DemoDashboard') || hasAccess('NewUI')) {
                    var onLoadCallable = $btn.data('on-load');

                    if (onLoadCallable && typeof window[onLoadCallable] === 'function') {
                        window[onLoadCallable](plugin);
                    }
                }
            },
        }).data('plugin_slidePanel').info();
    });

    $('body').unbind('click.FooterFormPanelLink').on('click.FooterFormPanelLink', '.js-form-panel-link', function (e) {
            var $btn = $(this);
            e.preventDefault();
            $('.js-info-panel').slidePanel({
                panel_class: 'bg-silver',
                loading_icon_selector: '.dataTables_processing',
                content_url: $(this).attr('href'),
                onLoad: function(){
                    var onLoadCallable = $btn.data('on-load');

                    if (onLoadCallable && typeof window[onLoadCallable] === 'function') {
                        window[onLoadCallable]();
                    }
                },
                beforePost: function(){
                    var beforePostCallable = $btn.data('before-post');

                    if (beforePostCallable && typeof window[beforePostCallable] === 'function') {
                        return window[beforePostCallable]();
                    }

                    return true;
                },
                onPost: function(response){
                    var onPostCallable = $btn.data('on-post');
                    var redirectLink = $btn.data('redirect-link');

                    if (onPostCallable && typeof window[onPostCallable] === 'function') {
                        return window[onPostCallable](response);
                    } else if (redirectLink){
                        window.location.href = redirectLink;
                    }
                }
            }).data('plugin_slidePanel').form();
       });

    $('.js-widget-box').each(function(){
        var $widget = $(this);
        $widget.on('reload-widget', function(){
            $.get($widget.attr('data-url'), function(data){
                $widget.html(data);
            });
        });
        $.get($widget.attr('data-url'), function(data){
            $widget.html(data);
        });
    });

    //Force Fill Out Modal
    var showModal = $('#finish-account-settings').attr('data-show-alert');
    var accountSettings = '/settings/account';
    var marketingSettings = '/settings/marketing';
    var emailSettings = '/settings/email';
    var mlsSettings = '/settings/mls';

    if (showModal) {
        $('#finish-account-settings').modal('show');
    }

    /* This fixes the second modals scrolling issue
    ------------------------------------------------ */
    $('.modal').on('shown.bs.modal', function() {
        if (!$('.modal-open').length) {
            $('body').addClass('modal-open');
        }
    }).on('hidden.bs.modal', function() {
        if (!$('.modal-open').length && $('.modal.fade.in').length) {
            $('body').addClass('modal-open');
        }
    });

    /* File Upload */

    var ul = $('#upload ul');

    $('#drop a,#library-drop a').click(function(){
        $(this).parent().find('input').click();
    });

    $(document.body).on('click', '.delete-library-image', function(e){
        e.preventDefault();
        var deletebtn = $(this);
        confirmModal('Are you absolutely sure you want to delete this permanantly?').then(function() {
            window.location.href = deletebtn.attr("href");
        });
    });

    $('#library-upload').fileupload({
        dropZone: $('#library-drop'),
        add: function (e, data) {
            var tpl = $('<li class="working"><input type="text" value="0" data-width="30" data-height="30" data-fgColor="#428BCA" data-readOnly="1" data-bgColor="#FFFFFF" /><p></p><span></span></li>');
            tpl.find('p').text(data.files[0].name).append('<i>' + formatFileSize(data.files[0].size) + '</i>');
            data.context = tpl.appendTo('ul#library-image-list');
            tpl.find('input').knob();
            tpl.find('span').click(function(){
                if(tpl.hasClass('working')){
                    jqXHR.abort();
                }
            });
            var jqXHR = data.submit();
        },
        progress: function( e, data ){
            var progress = parseInt(data.loaded / data.total * 100, 10);
            data.context.find('input').val(progress).change();
            if( progress == 100 ){
                data.context.removeClass('working').delay(2000).fadeOut( function() {
                    $(this).remove();
                });
            }
        },
        done: function( e, data ) {
            if ( 'error' == data.result.status ) {
                data.context.addClass('error');
            } else {
                var resultsHtml = '';
                resultsHtml += '<div class="col-md-3 col-lg-2 col-sm-4 col-xs-6">';
                    resultsHtml += '<div id="js-image-'+data.result.imageid+'" class="square col-square-12 js-image square--cover" data-image-url="'+data.result.src+'" style="background:url('+data.result.src+');">';
                        resultsHtml += '<div class="square-overlay">';
                            resultsHtml += '<button class="btn btn-sm btn-primary center-absolute js-expand-btn" data-target="#expandImage" data-toggle="modal" data-image-id="'+data.result.imageid+'" data-type-id="team_logo">View</button>';
                            resultsHtml += '<div class="square-bottom">';
                                resultsHtml += '<div class="square-delete pull-left js-delete-image-btn" data-image-id="'+data.result.imageid+'">';
                                    resultsHtml += '<a target="_blank" href="/image/delete/'+data.result.imageid+'"><i class="fa fa-trash"></i></a>';
                                resultsHtml += '</div>';
                            resultsHtml += '</div>';
                        resultsHtml += '</div>';
                    resultsHtml += '</div>';
                resultsHtml += '</div>';

                $('#library-images').prepend(resultsHtml);
            }
        },
        fail:function( e, data ){
            data.context.addClass('error');
            FlashMessage.message({
                type: 'error',
                message: $('<div/>').html(data.jqXHR.responseJSON.message).text(),
                duration: 5000,
                showClose: true
            });
        }
    });

    $(document).on('drop dragover', function (e) {
        e.preventDefault();
    });

    $('div#library-images').on('click', '.js-expand-btn', function(){
        var imageId = $(this).data('image-id');
        var imageElement = '#js-image-' + imageId;
        var imageUrl = $(imageElement).data('image-url');
        $(".js-expand-image").attr("src", imageUrl);
    });

    /*notifications*/
    $(document).on('click', '.dismiss-notification', function(event){
        event.preventDefault();
        var btn = $(this);
        var note_id = btn.data('note-id');
        $.ajax({
            url: '/notification/dismiss',
            type: 'post',
            data: {'note_id': note_id},
            dataType: 'json',
            success: function(response){
                if(response.status == 1) {
                    $('#note-' + note_id).fadeOut();
                    $('#notification-header-count').html(response.count);
                    $('#notifications-count').html(response.count);
                    if(response.count == 0){
                        $('#notifications-count').hide();
                    }
                }
            }
        });
    });

    $('.dismiss-alert-notification').click(function(event){
        event.preventDefault();
        var btn = $(this);
        var note_id = btn.data('note-id');
        var user_id = btn.data('user-id');
        $.ajax({
            url: '/notification/alert/dismiss',
            type: 'post',
            data: {'note_id': note_id, 'user_id': user_id},
            dataType: 'json',
            success: function(response){
                if(response.status == 1) {
                    $('#listnote-' + note_id).fadeOut();
                }
            }
        });
    });

    $('#create-broadcast-notification').click(function(event){
        event.preventDefault();
        $.ajax({
            url: '/notification/broadcast/create',
            type: 'post',
            data: $('#notification-details-form').serialize(),
            dataType: 'json',
            success: function(response){
                location.reload(true);
            }
        });
    });

    $('#add-notification').click(function(event){
        event.preventDefault();
        $('#new-broadcast-notification-dialog').modal({
            keyboard: false,
            backdrop: 'static'
        });
    });

    $('.collapse-sps').on('hide.bs.collapse', function() {
        $(this).parent('.panel-sps').removeClass('active');
    });

    $('.collapse-sps').on('hidden.bs.collapse', function() {
        if (!$('.collapse-sps.in').length) {
            $('.sps-preview').css('padding-left', '70px');
        }
    });

    $('.collapse-sps').on('show.bs.collapse', function() {
        $(this).parent('.panel-sps').removeClass('active');
        $(this).parent('.panel-sps').addClass('active');
    });

    $('.collapse-sps').on('shown.bs.collapse', function() {
        if ($('.collapse-sps.in').length && !isWindowConstrainedToMobileThreshold()) {
            $('.sps-preview').css('padding-left', '370px');
        }
    });

    // analyticsTagsEnabled is set in header templates by consulting pet.google-pendo-analytics-tags
    // feature flag

    try {
        if (analyticsTagsEnabled === 1) {
            const pendoApiKey = $("meta[name='pendo-api-key']").attr('content');

            if (!pendoApiKey) {
                console.warn('Pendo api key not found.');
            } else {
                pendo(pendoApiKey, window.user);
            }
        }
    } catch (e) {
        console.error(e.message);
    }

    const gtmApiKey = $("meta[name='gtm-api-key']").attr('content');
    googleTagManager(gtmApiKey, window.user);
});
